import React, { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import LogoLoader from 'components/Loader/LogoLoader';
import { useAllowedSidebarData } from 'hooks/common/useAllowedSidebarData';

const Dashboard: React.FC<unknown> = () => {
  const location = useLocation();
  const { allowedSideBarData } = useAllowedSidebarData();

  if (allowedSideBarData.length) {
    // transferring route state
    return <Navigate to={{ ...location, pathname: allowedSideBarData[0].path }} />;
  } else return <LogoLoader />;
};

export default memo(Dashboard);
